import { atom } from "recoil";

const AirlineIataAtom = atom<string>({
    default: '',
    key: 'airlineIataAtomKey'
})

export default AirlineIataAtom;